import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import axios from 'axios';
import ProduktList from '../../components/Produkt/ProduktList';
import { getProducentStorage } from '../../dao/DAO';
import {
    useParams
} from "react-router-dom";
const DAO_PRODUCENT_URL = process.env.REACT_APP_PS_AMARKA_SITE + '/api/' + process.env.REACT_APP_PS_AMARKA_API_VER + '/producent';
export default function KatalogSzukaj() {
    let { str } = useParams();
    const [katalogprodukty, setKatalogProdukty] = useState([]);
    const producent=getProducentStorage();
    const [loading,setLoading]=useState(true);
    const katalogProdukty = async () => {
        const res = await axios(DAO_PRODUCENT_URL, {
            method: 'POST',
            withCredentials: false,
            headers: {
                'Accept': 'application/json'
            },
            data: { operacja: "katalog_szukaj",nip:producent.nip,str:str }
        }).then((response) => {
           console.log("katalogProdukty resp:" + JSON.stringify(response.data));
            if (typeof (response.data.error) != 'undefined') {
                console.log("show errorssss33" + JSON.stringify(response.data.error));
                return null;
            }
            return response.data.produkty;
        }).catch(err => console.log(err.message));
        if (res !== null) {
           setKatalogProdukty(res);
        }
        setLoading(false);
    };
    useEffect(() => {
        katalogProdukty();
    }, katalogprodukty);
    if(loading){
        return (<><img className="d-block mx-auto ladowanie" src={process.env.PUBLIC_URL+ "/img/loading.gif"} width="250px" height="250px" /></>);
    }else if (katalogprodukty && katalogprodukty.length) {
        const list = katalogprodukty.map((item, key) => {
            return (<ProduktList key={item.id_produkt} produkt={item} />);
        });
        return (
            <Table className="tabela-table" striped bordered hover size="sm">
            
                <tbody>
                    {list}
                </tbody>
            </Table>
        );
    } else {
        return (<>Brak produktów dla <strong>{str}</strong></>);
    }
}